'use client'

/**
 * Purpose: Survey oily/dry axis page — slider when self-knowledge is yes, else questionnaire.
 * Inputs: formState, updateSection, setSlider, and tPages translator.
 * Outputs: SkinAxisSlider or SectionPage with OILY_DRY_QUESTIONS.
 */

import type { FormState } from '@lib/models/types'
import { OILY_DRY_QUESTIONS } from '@lib/survey-questions'
import { SectionPage } from '@components/pages/SectionPage/SectionPage'
import { SkinAxisSlider } from '@components/sliders/SkinAxisSlider/SkinAxisSlider'

export function SurveyOilyDryPage({
  formState,
  updateSection,
  setSlider,
  tPages,
}: {
  formState: FormState
  updateSection: (
    section: 'oilyDryAnswers',
    key: string,
    value: string,
  ) => void
  setSlider: (axis: 'oilyDry', value: number) => void
  // updateSection writes one questionnaire answer key at a time.
  tPages: (key: string) => string
}) {
  // "I know my skin" → single slider; otherwise full question set.
  if (formState.skinKnowledge.oilyDry) {
    return (
      <div id="survey-oily-dry-page">
        {/* Self-reported axis value — skips the multi-question branch. */}
        <SkinAxisSlider
          value={formState.sliderValues.oilyDry}
          onChange={(v) => setSlider('oilyDry', v)}
          title={tPages('oilyDrySlider.title')}
          description={tPages('oilyDrySlider.description')}
          leftLabel={tPages('oilyDrySlider.leftLabel')}
          rightLabel={tPages('oilyDrySlider.rightLabel')}
        />
      </div>
    )
  }

  // Detailed questionnaire when user does not self-report axis knowledge.
  return (
    <div id="survey-oily-dry-page">
      <SectionPage
        sectionKey="oilyDry"
        questions={OILY_DRY_QUESTIONS}
        answers={formState.oilyDryAnswers}
        onAnswer={(k, v) => updateSection('oilyDryAnswers', k, v)}
      />
    </div>
  )
}
